import { render, staticRenderFns } from "./ClcResolutionsBadSaleDasboard.vue?vue&type=template&id=365de2a8&"
import script from "./ClcResolutionsBadSaleDasboard.vue?vue&type=script&lang=js&"
export * from "./ClcResolutionsBadSaleDasboard.vue?vue&type=script&lang=js&"
import style0 from "./ClcResolutionsBadSaleDasboard.vue?vue&type=style&index=0&id=365de2a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports